import InputMask from 'react-input-mask';
import  react, {useEffect,useState, forwardRef} from "react";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import labels from 'react-phone-number-input/locale/pt-BR.json'

const PhoneInternational = forwardRef((props, ref) => {

    let [value,updateValue] = useState();
    let [error,updateError] = useState();
    let className = '';

    const handleChange = value => {
        if(value){
            updateValue(value);
            let element = {
                target: {
                    name: props.name,
                    value: value.replace(/([^\d])+/gim, '')
                }
            }
            props.onChange(element);
        }
    };

    useEffect(() => {
        let tempValue = ''; 
        if(props.value !=''){
            tempValue = '+'+props.value.replace(/([^\d])+/gim, '');
        }
        updateValue(tempValue);
    }, []);

    if(props.error){
        className="is-invalid";
    }
    
    return (
        <div ref={ref}>
            <PhoneInput
                international={true}
                countryCallingCodeEditable={false}
                defaultCountry="BR"
                placeholder="Informe o número de telefone"
                value={value}
                onChange={handleChange}
                disabled={props.readOnly}
                labels={labels}
                autoFocus={props.autoFocus?true:false}
            />
            {props.error && (
                <span id="terms-error" className="error invalid-feedback" style={{display:'inline'}}>{props.error}</span>
            )}
        </div>
    );
})
export default PhoneInternational;
